module.exports = __webpack_public_path__ + "img/NoContent.5ff33323.svg";